var $049ab8e2dc69b622$exports = {};
$049ab8e2dc69b622$exports = {
    "collapse": `Samenvouwen`,
    "columnResizer": `Groottewijziging van kolom`,
    "drag": `Slepen`,
    "expand": `Uitvouwen`,
    "loading": `Laden...`,
    "loadingMore": `Meer laden...`,
    "resizeColumn": `Kolomgrootte wijzigen`,
    "sortAscending": `Oplopend sorteren`,
    "sortDescending": `Aflopend sorteren`
};


export {$049ab8e2dc69b622$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
